import { create } from 'zustand';

const useUIStore = create((set) => ({
  // Sidebar State
  isSidebarOpen: true,
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  closeSidebar: () => set({ isSidebarOpen: false }),
  
  // Upgrade Modal State
  isUpgradeModalOpen: false,
  upgradeModalFeature: '',
  openUpgradeModal: (featureName) => set({ 
    isUpgradeModalOpen: true, 
    upgradeModalFeature: featureName || 'general' 
  }),
  closeUpgradeModal: () => set({ 
    isUpgradeModalOpen: false, 
    upgradeModalFeature: '' 
  }),
  
  // Ficha Modal State
  isFichaModalOpen: false,
  openFichaModal: () => set({ isFichaModalOpen: true }),
  closeFichaModal: () => set({ isFichaModalOpen: false }),
  
  // CI-001: Quick Booking Modal State
  isQuickBookingOpen: false,
  quickBookingPrefill: null,  // Cita data for re-agendar
  openQuickBooking: (prefillData = null) => set({ 
    isQuickBookingOpen: true, 
    quickBookingPrefill: prefillData 
  }),
  closeQuickBooking: () => set({ 
    isQuickBookingOpen: false, 
    quickBookingPrefill: null 
  }),
}));

export default useUIStore;
